import { PromoCode } from '../../lib/types/models/promo-code/promo-code'
import { PromoCodeInput } from '../../lib/types/models/promo-code/promo-code-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createPromoCode(data: PromoCodeInput) {
  return restApiClient.url(constructApiUrl(API.promoCodes.create.url, null)).post<PromoCode>(data)
}
